import { mergeFieldsRight } from './random_utils'

export function interpretResp(apiResp) {
    const { data, included } = apiResp

    if (Array.isArray(data)) {
        return data.map(item => formatResp(item, included))
    }
    return formatResp(data, included)
}

export function formatResp(data, included = []) {
    const { id, attributes, relationships } = data

    const includedMeta = relationships ? Object.keys(relationships).reduce((acc, c) => acc.concat(relationships[c].data), []) : []
    const includedData = includedMeta.length > 0 ? getIncluded(included, includedMeta) : {}

    return Object.assign({}, {id: id}, attributes, includedData)
}

function getIncluded(included, inclMeta) {
    return inclMeta.reduce((acc, c) => Object.assign({}, acc, mergeFieldsRight(acc, findIncluded(included, c))), {})
}

function findIncluded(included, search) {
    const found = included.find(item => item.type === search.type && item.id === search.id)
    return interpretIncl(found)
}

// if resp contains included data ensure that you add the type to this function
export function interpretIncl(inclData) {
    const { type, id, attributes } = inclData // eslint-disable-line no-unused-vars
    switch (type) {
        case "emails":
            return { email: attributes }
        case "userSummaries":
            return attributes
        case "members":
            return { memberships: attributes }
        case "teams":
            return { teams: {id: id, ...attributes} }
        case "tagReports":
            return { tagReports: {id: id, ...attributes} }
        case "goaltags":
            return { tags: {id: id, ...attributes} }
        case "goalusers":
            return { users: {id: id, ...attributes} }
        case "payments":
            return { payments: {id: id, ...attributes} }
        default:
            return {}
    }
}

export function interpretErrors(apiResp) {
    const { errors } = apiResp

    if (Array.isArray(errors)) {
        return errors.map(item => formatError(item))
    }
    return formatError(errors)
}

export function formatError(error) {
    const { detail } = error
    return detail
}

export const formatTagReportQueries = (meta) => {
    const formatQuery = (meta) => {
        const { id, ...attributes} = meta
        return {
            "type": "tagReportRangeQueries",
            "attributes": attributes,
            "id": id,
        }
    }

    return {
        "data": {
            "type": "tagReportRangeQueryContainers",
            "relationships": {
                "tagReportRangeQueries": {
                    "data": meta.map( query => formatQuery(query)),
                },
            },
        },
    }
}

export const formatStripeToken = (
    tokenId,
    paymentPlan,
    teamId,
    cardLast4,
    cardBrand,
    cardExp,
) => {
    return {
        data: {
            type: "tokens",
            attributes: {
                tokenId: tokenId,
                paymentPlan: paymentPlan,
                teamId: teamId,
                cardLast4,
                cardBrand,
                cardExp,
            },
        },
    }
}

export const formatTokenUpdatePaymentSource = (tokenId) => {
    return {
        "data": {
            "type":"tokens",
            "attributes": {
                "tokenId": tokenId,
            },
        },
    }
}

export const formatGoal = (meta) => {
    const formatGoalTags = (attributes) => {
        return {
            "type": "goaltags",
            attributes,
        }
    }

    const formatGoalUsers = (attributes) => {
        return {
            "type": "goalusers",
            attributes,
        }
    }

    const { tags, users, ...attributes } = meta

    return {
        "data": {
            "type": "goals",
            attributes,
            "id": attributes.id,
            "relationships": {
                "goaltags": {
                    "data": tags.map( tag => formatGoalTags(tag)),
                },
                "goalusers": {
                    "data": users.map( user => formatGoalUsers(user)),
                },
            },
        },
    }
}


export function formatMeta(meta, type) {
    const { id, ...attributes} = meta
    return {
        "data": {
            "type": type,
            "attributes": attributes,
            "id": id,
        },
    }
}



function prefix(i) {
    return i === 0 ? '?' : '&'
}

export function formatQueryParams(params={}) {
    const paramKeys = Object.keys(params)
    if (paramKeys.length === 0) return ''
    return paramKeys.reduce((acc, c, i) => acc + `${prefix(i)}${c}=${params[c]}`, '')
}

export function handleResp(resp) {
    return resp.json().then(json => interpretResp(json))
}

export function compose(...functions) {
    return functions.reduce((f, g) => (...args) => f(g(...args)))
}

export function handleGraphQlResp(body) {
    if (body.errors) {
        return body.errors
    }
    return body.data
}


// WEBPACK FOOTER //
// ./src/util/api_utils.js